export default __webpack_public_path__ + "static/media/cube_cut.10738105.png";